module.exports = __webpack_public_path__ + "static/media/VISA_ELECTRON.4b1c43b1.png";